export default __webpack_public_path__ + "static/media/dinamika.3fab1622.png";